import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { Html5Qrcode } from "html5-qrcode";
import { QrDimensions } from "html5-qrcode/src/core";
import { delay } from "src/services/utils/promise.utils";

function getQrBoxDimensions(viewfinderHeight: number, viewfinderWidth: number): QrDimensions {
  const threeQuarterOfHeight = Math.floor(viewfinderHeight * 0.75);
  const threeQuarterOfWidth = Math.floor(viewfinderWidth * 0.75);

  const maxedOutHeight = Math.min(threeQuarterOfHeight, 300);
  const maxedOutWidth = Math.min(threeQuarterOfWidth, 300);

  const smallestDimensionForSquareSize = Math.max(maxedOutHeight, maxedOutWidth, 50);

  return { height: smallestDimensionForSquareSize, width: smallestDimensionForSquareSize };
}

@Component({
  selector: "rc-scanner",
  templateUrl: "./scanner.component.html",
  styleUrls: ["./scanner.component.scss"],
  standalone: false,
})
export class ScannerComponent implements OnInit, OnDestroy {
  @Output() public handleQrCodeScanned = new EventEmitter<string>();

  public loading: boolean = true;

  private alreadyScannedCodes: string[] = [];
  private scannerInstance: Html5Qrcode;

  public constructor(public readonly navigationService: NavigationService) {}

  public async ngOnInit(): Promise<void> {
    await this.initScannerForWeb();

    this.loading = false;
  }

  public async ngOnDestroy(): Promise<void> {
    const scannerState = this.scannerInstance?.getState();

    if (scannerState === 2) {
      await this.scannerInstance.stop();
      this.scannerInstance.clear();
    }
  }

  private async initScannerForWeb(): Promise<void> {
    // Required to make sure that element is rendered properly before initializing camera
    await delay(1000);

    this.scannerInstance = new Html5Qrcode("qr-reader");
    const preferBackCamera = "environment";

    await this.scannerInstance.start(
      { facingMode: preferBackCamera },
      {
        fps: 15,
        qrbox: (viewfinderWidth: number, viewfinderHeight: number) =>
          getQrBoxDimensions(viewfinderHeight, viewfinderWidth),
      },

      async (decodedText) => {
        if (this.alreadyScannedCodes.includes(decodedText)) {
          return;
        }

        this.alreadyScannedCodes.push(decodedText);
        this.handleQrCodeScanned.emit(decodedText);
      },
      undefined,
    );
  }
}
